module.exports = __webpack_public_path__ + "static/media/transaction-hash.af19d9b4.svg";